<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col >
               <v-select
                  :items=partCategories
                  label="Κατηγορία Ανταλλακτικού"
                  v-model="category"
                  :hint="`Cat-ID: ${category}`"
                  persistent-hint
                  :suffix="fi"
                  item-text="Description"
                  item-value="CatId"
                  clearable
                ></v-select>
            </v-col>
            <v-col>
              <v-combobox
                v-model="manf"
                :items="uniqueManufacturers"
                prepend-icon="mdi-factory"
                label="Κατασκευαστής"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(manf, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
              </v-row>
           <v-tabs
             v-model="vtab"
            align-with-title
            >
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab
            v-for="item in vtabs"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>

        </v-card-text>
      </v-card>
    </template>

  <template>
    <v-tabs-items class="mt-2 pa-2" v-model="vtab">
      <v-tab-item :key="vtabs[0]">
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
      <h1 class="mr-2 subheading grey--text">Κέρδος Ανταλλακτικού</h1>
       <v-spacer/>
       <v-chip label>Κέρδος: {{ tocurr(sumField(parts, 'Profits') || 0) }}</v-chip>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="parts"
      loading: false
      :search="search"
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      single-expand: true
      :expanded.sync="expanded"
      show-group-by
      @current-items="updateSum"
      loading-text="Loading... Please wait"
    >
    <template v-slot:item.actions="{ item }">
         <v-btn
          icon
          small
          :to="{name: 'part-info', params: {id: item.id}}"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>

     </template>
   <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div v-if="header.value == 'Profits'">
                    {{ tocurr(partsProfit) }}
                </div>
                <div v-if="header.value == 'Checkout'">
                    {{ partsQty}}
                </div>

                <div v-if="header.value == 'Cost'">
                    {{ tocurr(partsCost) }}
                </div>

                <div v-if="header.value == 'Sales'">
                    {{ tocurr(partsSales) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
    <template v-slot:item.Sales="{ item }">
       {{ tocurr(item.Sales) }}
    </template>
    <template v-slot:item.Cost="{ item }">
       {{ tocurr(item.Cost) }}
    </template>
    <template v-slot:item.Profits="{ item }">
       {{ tocurr(item.Profits) }}
    </template>
    <template v-slot:item.ProfitsPc="{ item }">
      {{ ( item.ProfitsPc * 100).toFixed(2) }}
    </template>
    <template v-slot:item.Qty="{ item }">
      {{ (item.Qty).toFixed(2) }}
    </template>
    <template v-slot:item.SuggestedPrice="{ item }">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >      {{ $tocurr(item.SuggestedPrice) }}</span>
      </template>
      <span>{{((item.SuggestedPrice/item.PartCost-1)*100).toFixed(0)}}% - {{$tocurr(item.SuggestedPrice-item.PartCost)}}</span>
    </v-tooltip>
    </template>
     <template v-slot:item.CategoryId="{ item }">
       {{ partCategories.find(i => i.CatId === item.CategoryId).Description }}
    </template>
    </v-data-table>
  </v-card>
  </v-tab-item>
  <v-tab-item :key="vtabs[1]">

      <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
   <apexchart
      ref="barChart"
      type="bar"
      :options="chartOptions"
      :series="series"></apexchart>
    </v-sheet>
     <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Κέρδος ανα κατηγορία Ανταλλακτικού 2023
      </div>
      <div class="subheading font-weight-light grey--text">
        Κέρδος ανα κατηγορία Ανταλλακτικού 2024
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-delta
      </v-icon>
      <span class="text-caption grey--text font-weight-light">Μέση τιμή 0</span>
    </v-card-text>
  </v-card>


    </v-tab-item>
     <v-tab-item :key="vtabs[2]">

      <v-card
    class="mt-4 mx-auto"
    max-width="80%"
    :loading="loading"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
   <apexchart
      ref="barChart2"
      type="bar"
      :options="chartOptionsProf"
      :series="profit_series"></apexchart>
    </v-sheet>
     <v-card-text class="pt-0">
  <v-select
      v-model="selectedYear"
      @change="updateChartOnYear"
      :items="availableYears"
      :disabled="loading"
    >
    </v-select>
     <div class="text-h6 font-weight-light mb-2">
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              Κέρδος Ανταλλακτικών: {{ $tocurr(totalPartsProfit) }}
            </span>
          </template>
          <span>Περιθώριο κέρδους: {{ ((totalPartsProfit / totalPartsCost) * 100).toFixed(2) }}%</span>
        </v-tooltip>
      </div>
      <div>Kόστος Ανταλλακτικών: {{ $tocurr(totalPartsPrice) }}</div>
      <div>Kόστος Αναλώσιμων: {{ $tocurr(totalConsumablesCost) }}</div>
      <div>Κέρδος Εργασίας: {{ $tocurr(totalServiceCost) }}</div>
      <div>Τζίρος: {{ $tocurr(totalPartsCost+totalServiceCost) }}</div>
      <!-- <div>Τζίρος: {{ $tocurr(totalRepairs+totalConsumablesCost) }}</div> -->
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              ΤΙΜ: {{ $tocurr(totalInvoiced) }}
            </span>
          </template>
          <span>Ποσοστό: {{ ((totalInvoiced) / (totalPartsCost + totalServiceCost) * 100).toFixed(2) }}%</span>
        </v-tooltip>
      </div>
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              MA: {{ $tocurr(totalPartsCost+totalServiceCost-totalInvoiced) }}
            </span>
          </template>
          <span>Ποσοστό: {{ ((totalPartsCost+totalServiceCost-totalInvoiced) / (totalPartsCost + totalServiceCost) * 100).toFixed(2) }}%</span>
        </v-tooltip>
      </div>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              Συνολικό Κέρδος: {{ $tocurr(totalPartsProfit+totalServiceCost) }} ({{ ((totalProfit(selectedYear)/totalProfit(selectedYear-1))*100).toFixed(2) }}%)
            </span>
          </template>
          <span>Περιθώριο κέρδους: {{ ((totalPartsProfit+totalServiceCost) / (totalPartsCost + totalServiceCost) * 100).toFixed(2) }}%</span>
        </v-tooltip>
      </div>
        </div>
      <div class="subheading font-weight-light grey--text">
        Κέρδος ανα μήνα {{ selectedYear }}
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-delta
      </v-icon>
      <span class="text-caption grey--text font-weight-light">Σύνολο</span>
    </v-card-text>
  </v-card>


  </v-tab-item>

  <v-tab-item :key="vtabs[3]">
    <v-card class="mt-4 mx-auto" max-width="90%">
      <v-card-title>
        <span class="headline">Στατιστικά ανά Δραστηριότητα</span>
        <v-spacer/>
        <v-select
          v-model="selectedActivityYear"
          :items="availableActivityYears"
          label="Έτος"
          @change="updateActivityCharts"
          style="max-width: 120px"
        />
        <v-chip
          class="ml-4"
          color="primary"
          outlined
          v-if="brakeRepairRatio !== null"
        >
          Αναλογία Επισκευών Φρένων: {{ brakeRepairRatio }}
        </v-chip>
      </v-card-title>
      <v-card-text>
        <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model.number="minRepairsFilter"
            label="Ελάχιστες Επισκευές"
            type="number"
            min="0"
            dense
            outlined
            @change="updateActivityCharts"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model.number="minProfitFilter"
            label="Ελάχιστο Κέρδος (€)"
            type="number"
            min="0"
            dense
            outlined
            @change="updateActivityCharts"
          />
        </v-col>
      </v-row>
        <div>
          <apexchart
            type="bar"
            height="350"
            :options="activityChartOptions"
            :series="activityChartSeries"
          />
        </div>
        <v-divider class="my-6"></v-divider>
        <div>
          <apexchart
            type="bar"
            :options="activityProfitOptions"
            :series="activityProfitSeries"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-tab-item>

  <v-tab-item :key="vtabs[4]">
  <v-card class="mt-4 mx-auto" max-width="95%">
    <v-card-title>
      <span class="headline">Κέρδη ανά Μήνα και Κατηγορία</span>
      <v-spacer/>
      <v-select
        v-model="selectedCategoryYear"
        :items="availableYears"
        label="Έτος"
        @change="fetchCategoryProfits"
        style="max-width: 120px"
        :disabled="loading"
      />
    </v-card-title>
    <v-card-text>
      <apexchart
        type="bar"
        height="800"
        :options="categoryStackedChartOptions"
        :series="categoryStackedChartSeries"
      />
    </v-card-text>
  </v-card>
</v-tab-item>

</v-tabs-items>
</template>
  </v-container>
</template>

<script>

//import QuoteCard from '../../components/QuoteCard.vue';
import VueApexCharts from 'vue-apexcharts'

const MONTHS = [ "Ιαν.", "Φεβ.", "Μαρ.", "Απρ.", "Μάιος", "Ιούν.",
       "Ιούλ.", "Αυγ.", "Σεπτ.", "Οκτ.", "Νοέ.", "Δεκ." ];

export default {
  components: {
 //   QuoteCard
      apexchart: VueApexCharts,
  },
  computed: {
      partsCost () {
        return this.parts.reduce((a, b) => a + (b.Cost|| 0), 0);
      },
      partsSales() {
        return this.parts.reduce((a, b) => a + (b.Sales|| 0), 0);
      },
      partsProfit() {
        return this.parts.reduce((a, b) => a + (b.Profits|| 0), 0);
      },
      partsQty() {
        return this.parts.reduce((a, b) => a + (b.StockQty|| 0), 0);
      },
      fi() {
        if (!this.category) return;
        return this.tocurr(this.sumField(this.filteredParts, 'Profits'))
      },
      isAdmin() {
          if (!this.$store.state.authentication.user) return false;
          return this.$store.state.authentication.user.scopes.includes("income");
      },
      uniqueManufacturers () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.parts, 'Manufacturer');
      },
      totalPartsProfit() {
      return Object.values(this.repair_profits).reduce((sum, month) => {
        return sum + (month.parts_profit|| 0)
      }, 0) - Object.values(this.consume).reduce((sum, month) => {
          return sum + (month.parts_cost || 0)
        }, 0)
      },
      totalPartsPrice() {
        return Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.parts_cost || 0)
        }, 0) - Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.parts_profit || 0)
        }, 0)
      },
      totalPartsCost() {
        return Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.parts_cost || 0)
        }, 0)
      },
      totalConsumablesCost() {
        return Object.values(this.consume).reduce((sum, month) => {
          return sum + (month.parts_cost || 0)
        }, 0)
      },
      totalRepairs() {
        return Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.repairs_total || 0)
        }, 0)
      },
      totalInvoiced() {
        return Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.repairs_invoiced || 0)
        }, 0)
      },
      totalServiceCost() {
        return Object.values(this.repair_profits).reduce((sum, month) => {
          return sum + (month.service_cost || 0)
        }, 0)
      },
  },
  data() {
    return {
      menu: false,
      expanded: [],
      checkoutdialog: false,
      partQty: 0,
      partTechId: 1,
      loading: true,
      newPart: {CategoryId: 0},
      partCategories: [],
      search: '',
      inStock: false,
      parts: [],
      repairProfits:{2025: {1: { "part_profits": 0, "service_cost": 0}}, 2024: {1: {  "part_profits": 0, "service_cost": 0}}},
      repair_profits:{1: { "profit": 0}},
      consume:{1: { "part_cost": 0}},
      filteredParts: [],
      manf: [],
      category: null,
      supplier: null,
      months: MONTHS,
      uniqueSuppliers: [],
      vtab: null,
      vtabs: ['Πινακες', 'Γραφημα', 'Κερδη', 'Δραστηριότητες', 'Στατιστικά'],
      activityStats: {},
      activityChartSeries: [],
      activityChartOptions: {},
      activityProfitSeries: [],
      activityProfitOptions: {},
      minRepairsFilter: 0,
      minProfitFilter: 0,
      brakeRepairRatio: 0,
      selectedActivityYear: new Date().getFullYear(),
      selectedCategoryYear: new Date().getFullYear(),
      availableActivityYears: [2023, 2024, 2025, 2026], // Adjust as needed
      grossVprof: false,
      stackedPc: false,
      availableYears: [2023,2024,2025, 2026],
      selectedYear: new Date().getFullYear(), // Current year as default
      categoryStackedChartSeries: [],
      categoryStackedChartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
          }
        },
        xaxis: {
          categories: MONTHS,
          labels: { style: { fontSize: '16px' } }
        },
        yaxis: {
          title: { text: 'Κέρδος (€)' },
          labels: {
            formatter: this.$tocurr,
            style: {fontSize: '16px'}
          }
        },
        legend: { position: 'top' },
        tooltip: {
          y: {
            formatter: val => new Intl.NumberFormat("el-GR", {
              style: "currency",
              currency: "EUR"
            }).format(val)
          }
        },
        colors: [
          "#4E79A7", // Blue
          "#F28E2B", // Orange
          "#E15759", // Red
          "#76B7B2", // Teal
          "#59A14F", // Green
          "#EDC948", // Yellow
          "#B07AA1", // Purple
          "#FF9DA7", // Pink
          "#9C755F", // Brown
          "#7A6FCA",  // Violet
          "#BAB0AC", // Gray
        ],
        dataLabels: {
          enabled: false,
          total: {
            enabled: true,
            offsetY: -10,
            style: {
              fontSize: '16px',
              fontWeight: 900
            },
           formatter: this.$tocurr
        },
      },
    },
      rules:  {
        partId: value => {
            const pattern = /^\d{1,5}$/
            return pattern.test(value) || 'Invalid Part-ID.'
          },
      },
      headers: [
            {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'FmSku',
            width: '5%',
          },
          {
            text: 'Κωδικός Προμηθευτή',
            align: 'start',
            //sortable: false,
            value: 'SupplierSku',

            width: '5%',
          },
          { text: 'Κατηγορία', value: 'CategoryId', groupable: false, width: '5%',
          filter: (value) => {
            if (!this.category) return true;
            return value == this.category;
            },},
          { text: 'Περιγραφή', value: 'Description', groupable: false, width: '50%'},

         { text: 'Κέρδος', value: 'Profits', align: 'end', groupable: false },
         { text: 'Κέρδος %', value: 'ProfitsPc', align: 'center', width: '10%', groupable: false },
         { text: 'Τζίρος', value: 'Sales', align: 'end', groupable: false },
          { text: 'Αγορά', value: 'Cost', align: 'end', groupable: false },
        { text: 'Πωλήσεις', value: 'Qty', align: 'end', groupable: false},
          { text: 'Actions', value: 'Actions', groupable: false, width: '25%' },
        ],
      series: [{
            name: 'Profits',
            data: []
          }],
      profit_series: [{
            name: 'Profits',
            data: []
          }],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: this.$tocurr,
        },

        xaxis: {
          type: "category",
          categories: [],
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
        },
        legend: {
          position: "top",
          show: true,

        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: true,
          },
          labels: {
            show: true,
            style: {
              colors: [],
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 300,
              cssClass: 'apexcharts-yaxis-label',
          },

          }

        },

          tooltip: {
            enabled: true,
           y: {
              formatter: this.$tocurr,
           },
          },

        responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
        //title: {
        //  text: 'Εισπράξεις για το διάστημα',
        //  floating: true,
        //  offsetY: 330,
        //  align: 'center',
        //  style: {
        //    color: '#444'
        //  }
        //}
      },

       chartOptionsProf: {
            chart: {
              height: 250,
              type: 'bar',
              stacked: true,
               toolbar: {
                 show: true
               },
                 zoom: {
                 enabled: true
              }
            },
            plotOptions: {

              bar: {
              horizontal: true,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last', // 'all', 'last'
                columnWidth: '45%',
                dataLabels: {
                  total: {
                    enabled: true,
                    formatter: this.$tocurr,
                    style: {
                  fontSize: '14px',
                  fontWeight: 900
                }
                  },
                },
              },
            },
             dataLabels: {
                  enabled: true,
                  formatter: this.tocurr,
                  style: {
                    fontSize: '12px',
                   // colors: ["#304758"]
                  },
              },

            tooltip: {
              enabled: true,
            y: {
              formatter: function (value, { seriesIndex, dataPointIndex, w}) {
              if (seriesIndex == 2) {
                  const cost  = w.config.series[0].data[dataPointIndex].y;
                  const consumed  = w.config.series[1].data[dataPointIndex].y;
                  const profit = w.config.series[2].data[dataPointIndex].y;
                  const percentage = profit/(cost+profit) * 100;
                  const percentage1 = profit/(cost+profit+consumed) * 100;
                  const v = new Intl.NumberFormat("el-GR", {
                              style: "currency",
                              currency: "EUR",
                            }).format(value.toFixed(2));
                  return `${v} (${percentage.toFixed(2)}% - ${percentage1.toFixed(2)}%)`;
              }
              else if (seriesIndex == 1) {
                  const cost  = w.config.series[0].data[dataPointIndex].y;
                  const percentage = value/cost * 100;
                  const v = new Intl.NumberFormat("el-GR", {
                              style: "currency",
                              currency: "EUR",
                            }).format(value.toFixed(2));
                  return `Consumables: ${v} (${percentage.toFixed(2)}%)`;
              }
              else {
                  const v = new Intl.NumberFormat("el-GR", {
                              style: "currency",
                              currency: "EUR",
                            }).format(value.toFixed(2));
                  return `${v}`;

                }
            }
            },
            },
            legend: {
              position: 'right',
              offsetY: 40
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: true,
              },
              labels: {
                show: true,
               style: {
                colors: [],
                fontSize: '16px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 700,
                cssClass: 'apexcharts-yaxis-label',
          },
              }

            },

          },

    }
  },
  async created() {
    try {
      // Initialize available years (e.g., last 5 years)
      // const currentYear = new Date().getFullYear();
      // this.availableYears = Array.from(
      //  {length: 4},
      //  (_, i) => currentYear - i
      //).sort((a, b) => b - a); // Sort descending

      /*  const response = await this.$api.get(`/inventory/profits`);
        // console.log(response);
        this.parts = response.data.filter(e=>e.CategoryId<91);
        const catresponse = await this.$api.get('/inventory/parts/categories');
        // console.log(response);
        this.partCategories = catresponse.data;
        //this.uniqueSuppliers = this.uniqSup(this.parts);

        const rep_prof_resp = await this.$api.get('/repairs/profits', {params: {'start-date': '2023-12-01'}});
        this.repair_profits = rep_prof_resp.data[2024]
        */

      // Fetch initial data
      await Promise.all([
         this.fetchPartsData(),
        this.fetchRepairProfits(),
        // this.fetchActivityStats(),
        //this.fetchCategoryProfits(),
      ]);


        this.loading = false;
        this.updateChart();
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
      selectedActivityYear() {
        this.updateActivityCharts();
      },
},
  methods: {
    async fetchPartsData() {
      const [partsResponse, categoriesResponse] = await Promise.all([
        this.$api.get(`/inventory/profits`),
        this.$api.get('/inventory/parts/categories')
      ]);

      this.parts = partsResponse.data.filter(e => e.CategoryId < 91);
      this.partCategories = categoriesResponse.data;
    },

    async fetchRepairProfits() {
      try {
        const startDate = '2026-01-01';
        const response = await this.$api.get('/repairs/profits', {
          params: {
            'start-date': startDate
          }
        });
        this.repairProfits = response.data;
        this.repair_profits = this.repairProfits[this.selectedYear];
        // this.updateChart();
        const response2 = await this.$api.get('/repairs/self-consume', {
          params: {
            'start-date': startDate
          }
        });
        this.selfConsume = response2.data;
        this.consume = this.selfConsume[this.selectedYear];
      } catch (error) {
        console.error('Error fetching repair profits:', error);
      }
    },
    async fetchRepairProfitsYear(year) {
      this.loading = true;
      try {
        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;
        const response = await this.$api.get('/repairs/profits', {
          params: {
            'start-date': startDate,
            'end-date': endDate
          }
        });
        this.repairProfits[year] = response.data[year];
        this.repair_profits = this.repairProfits[year];
        // this.updateChart();
        const response2 = await this.$api.get('/repairs/self-consume', {
          params: {
            'start-date': startDate
          }
        });
        this.selfConsume = response2.data;
        this.consume = this.selfConsume[this.selectedYear];
      } catch (error) {
        console.error('Error fetching repair profits:', error);
      }
      this.loading = false;
    },
   async fetchActivityStats() {
    try {
      // Replace with your actual API endpoint
      const response = await this.$api.get('/repairs/profits_by_kad2');
      this.activityStats = response.data;
    } catch (error) {
      console.error('Error fetching activity stats:', error);
      this.activityStats = {};
    }
    },

    updateActivityCharts() {
      const year = this.selectedActivityYear;
      const stats = this.activityStats[year] || {};

      // Prepare categories (activity names)
      let categories = Object.keys(stats);

      // Filter by min repairs and min profit
      categories = categories.filter(activity => {
        const repairs = stats[activity].repairs_qty || 0;
        const profit = stats[activity].profit || 0;
        return repairs >= this.minRepairsFilter && profit >= this.minProfitFilter;
      });

      let brake_qty_total = 0
      let repairs_qty_total = 0

      categories.forEach(activity => {
        const repairs = stats[activity].repairs_qty || 0;
        const brakes = stats[activity].brakes_qty || 0;
        // Accumulate totals
        repairs_qty_total += repairs;
        brake_qty_total += brakes;
      });

      // Calculate overall ratio, avoid division by zero
      this.brakeRepairRatio = +((repairs_qty_total > 0 ? brake_qty_total / repairs_qty_total : 0)*100).toFixed(2);

// Now you can use brake_qty_total, repairs_qty_total, and overall_brake_repair_ratio as needed
      // Prepare series for stacked bar (repairs_qty, brakes_qty)
      const repairsData = [];
      const brakesData = [];
      categories.forEach(activity => {
        repairsData.push(stats[activity].repairs_qty - stats[activity].brakes_qty || 0);
        brakesData.push(stats[activity].brakes_qty || 0);
      });

      this.activityChartSeries = [
        { name: 'Άλλες επισκευές', data: repairsData },
        { name: 'Επισκευές Φρένων', data: brakesData }
      ];
      this.activityChartOptions = {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
          }
        },
        xaxis: {
          categories,
          labels: { style: { fontSize: '12px' } }
        },
        yaxis: {
          title: { text: 'Πλήθος Επισκευών' }
        },
        legend: { position: 'top' },
        tooltip: {
          y: { formatter: val => val }
        }
      };


      // Prepare series for profit bar chart
      const profitData = categories.map(activity => stats[activity].profit || 0);
      this.activityProfitSeries = [
        { name: 'Κέρδος', data: profitData }
      ];
      this.activityProfitOptions = {
        chart: {
          type: 'bar',
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: true, // Changed to true for horizontal bars
            columnWidth: '50%',
            dataLabels: {
                  position: 'top'
            },
          }
        },
        xaxis: {
          title: { text: 'Κέρδος (€)' },
          categories: categories,
          labels: {
            formatter: val => new Intl.NumberFormat("el-GR", {
              style: "currency",
              currency: "EUR"
            }).format(val)
          }
        },
        dataLabels: {
          enabled: true,
          formatter: this.$tocurr,
        },
        tooltip: {
          y: {
            formatter: val => new Intl.NumberFormat("el-GR", {
              style: "currency",
              currency: "EUR"
            }).format(val)
          }
        }
      };

      // Prepare array of activities with their stats for sorting
      const activityArray = categories.map(activity => ({
        name: activity,
        repairs: stats[activity].repairs_qty + stats[activity].brakes_qty || 0,
        profit: stats[activity].profit || 0
      }));

      // Sort by repairs descending
      activityArray.sort((a, b) => b.repairs - a.repairs);
      // Sort by profit descending
      activityArray.sort((a, b) => b.profit - a.profit);

    },

    async fetchCategoryProfits() {
    this.loading = true;
    try {
      const year = this.selectedCategoryYear;
      const startDate = `${year}-01-01`;
      const endDate = `${year}-12-31`;
      const response = await this.$api.get('/repairs/profits/by_type', {
        params: {
          'start-date': startDate,
          'end-date': endDate
        }
      });
      const yearData = response.data[year];
      if (!yearData) {
        this.categoryStackedChartSeries = [];
        this.categoryStackedChartOptions.xaxis.categories = MONTHS;
        this.loading = false;
        return;
      }
      // Gather all categories (excluding 'Εργασία' if you want)
      const allCategories = new Set();
      Object.values(yearData).forEach(monthObj => {
        Object.keys(monthObj).forEach(cat => allCategories.add(cat));
      });
      // Remove 'Εργασία' if you want only spare parts
      // allCategories.delete('Εργασία');
      // Prepare series data
      const series = [];
      for (const cat of allCategories) {
        const data = [];
        for (let m = 1; m <= 12; m++) {
          const monthObj = yearData[m] || {};
          data.push(monthObj[cat] || 0);
        }
        series.push({ name: cat, data });
      }
      this.categoryStackedChartSeries = series;
      this.categoryStackedChartOptions.xaxis.categories = MONTHS;
    } catch (error) {
      console.error('Error fetching category profits:', error);
      this.categoryStackedChartSeries = [];
    }
    this.loading = false;
  },

   async updateChartOnYear() {
      if (this.selectedYear in this.repairProfits) {
        this.repair_profits = this.repairProfits[this.selectedYear];
        this.consume = this.selfConsume[this.selectedYear];
      } else {
        await this.fetchRepairProfitsYear(this.selectedYear)
      }
      this.updateChart();
    },

    updateSum(e) {
        this.filteredParts = e
    },
    showdialog(item) {
      //console.log(item, this.timdialog)
      this.diaitems = item.line_items;
      this.timdialog = true;
    },
    close () {
          this.timdialog = false
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value.toFixed(2));
    },

    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    reduceCatId(items) {
    var result = [];
    items.reduce(function(res, value) {
    if (!res[value.CategoryId]) {
      res[value.CategoryId] = { catid: value.CategoryId, Profits: 0 };
      result.push(res[value.CategoryId])
    }
    res[value.CategoryId].Profits += value.Profits;
    return res;
  }, {})
    result.sort((a, b) => b.Profits - a.Profits)
    return result
  },
  uniqSup(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let supp = null;
    for (let val of items) {
      //If item is already added then move to the next item
      supp = val["Invoice"]["Supplier"]
      if (itemsFound[supp.Id]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(supp);

      //Mark it as added
      itemsFound[supp.Id] = true;
    }

    //Return the uniques
    return uniques;
  },
  totalProfit(year) {
    if (year in this.repairProfits) {
    return Object.values(this.repairProfits[year]).reduce((sum, month) => {
      return sum + (month.service_cost + month.parts_profit || 0)
    }, 0)
    } else {
      return 0
    }
  },
  updateChart () {
      let labels = [];
      let values =[{data: [], name: "Profit"}];
      let items = this.reduceCatId(this.parts)
      let desc = ''
      for (let ind in items) {
        console.log(ind, items[ind])
        desc = this.partCategories.find(i => i.CatId === items[ind].catid).Description
        console.log(desc)
        labels.push(desc);
        values[0].data.push({
         x: desc,
         y: items[ind].Profits,
         });
      }
      this.series = values

      let repValues = [
      {data: [], name: "Part Cost"},
      {data: [], name: "Consumables"},
      {data: [], name: "Part Profit"},
      {data: [], name: "Service"},
      ];
      //for (let i in this.repair_profits)  {
      for (let i = 1; i<13; i++)  {
        labels.push(i);
	if (i in this.repair_profits) {
          repValues[0].data.push({
               x: `${this.months[i-1]} - ${this.repair_profits[i]['repairs_qty']}` ,
               y: this.repair_profits[i]['parts_cost'] - this.repair_profits[i]['parts_profit'],
           })
          if (this.consume[i]) {
              repValues[1].data.push({
                  x: this.months[i-1],
                  y: this.consume[i]['parts_cost'],
              })
          } else {
              repValues[1].data.push({
                  x: this.months[i-1],
                  y: 0,
              })
          }
          repValues[2].data.push({
               x: this.months[i-1],
               y: this.repair_profits[i]['parts_profit'],
           })
           repValues[3].data.push({
               x: this.months[i-1],
               y: this.repair_profits[i]['service_cost'],
           })
	} else {
          repValues[0].data.push({
               x: `${this.months[i-1]} - 0`,
               y: 0,
           })
           repValues[1].data.push({
               x: this.months[i-1],
               y: 0,
           })
           repValues[2].data.push({
               x: this.months[i-1],
               y: 0,
           })
           repValues[3].data.push({
               x: this.months[i-1],
               y: 0,
           })
        }

        }
      this.profit_series = repValues

      //this.chartOptions.xaxis.categories = labels
      // this.chartOptions = {xaxis: {type: 'category', categories: labels, position: 'left'}}
    },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.manf = [...obj];
  },
  }
}
</script>
